import React, { useEffect,useState, Fragment } from 'react'; 
import './Protocolo.scss';

const images ={
    abc:require('./AssetsProtocolo/protocolo_imagen_texto.jpg'),
    last:{
        img:require('./AssetsProtocolo/imagen_caletascovid-19.jpg'),
        url:'https://www.arcgis.com/home/webmap/viewer.html?webmap=5b703c907a134a0fad706143c8c52891&extent=-123.9753,-54.7149,-20.4402,-14.8436'
    }
}

/**
 * Componente de protocolos en acordeon
 *
  */

const ProtocoloPage = () => {    
    const [imageOne,setImageOne] = useState(require('./AssetsProtocolo/img_recgen_min.jpg'));
    const [imageTwo,setImageTwo] = useState(require('./AssetsProtocolo/img_medpreve_min.jpg'));
    const [imageThree,setImagethree] = useState(require('./AssetsProtocolo/img_medprod_min.jpg'));

    useEffect(() => {
        // window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>    
            <div className="Protocolos">
                <Fragment>
                    <img className="protocolo" src={images.abc} alt=""/>
                    <img className="protocolo" src={imageOne} onClick={()=>{setImageOne(imageOne === require('./AssetsProtocolo/img_recgen_min.jpg') ?require('./AssetsProtocolo/img_recgen_max.jpg'): require('./AssetsProtocolo/img_recgen_min.jpg') )}} alt=""/>
                    <img className="protocolo" src={imageTwo} onClick={()=>{setImageTwo(imageTwo === require('./AssetsProtocolo/img_medpreve_min.jpg') ?require('./AssetsProtocolo/img_medpreve_max.jpg'): require('./AssetsProtocolo/img_medpreve_min.jpg'))}}  alt=""/>
                    <img className="protocolo" src={imageThree} onClick={()=>{setImagethree(imageThree === require('./AssetsProtocolo/img_medprod_min.jpg') ?require('./AssetsProtocolo/img_medprod_max.jpg'): require('./AssetsProtocolo/img_medprod_min.jpg'))}}  alt=""/>
                    <img className="protocolo" onClick={()=>{window.open(images.last.url,'_blank')}} src={images.last.img} alt=""/>
                </Fragment>
            
            </div>
        </Fragment>
    )
}

export default ProtocoloPage;